import Button from './button/button';
import 'edge/platform/atomic_design/molecules/module';

export default angular.module('edge.platform.atomic_design', ['edge.platform.atomic_design.molecules']).directive('gwButton', Button);


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/platform/atomic_design/module.js
// module id = 1020
// module chunks = 0